<template>
    <client-page>
        <sub-visual sh="Contact US" bg="/images/sub/visual/sv6.jpg"> </sub-visual>

        <section class="section section--first">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Contact US</h2>
                </div>

                <v-simple-table class="v-simple-table v-data-table--default v-data-table--no-active text-center">
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Person in Charge</th>
                            <th>E-mail</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="5">Analyzer Package System</td>
                            <td>Hong-ki Park</td>
                            <td><a href="mailto:richard@kiesys.co.kr" class="primary--text text-decoration-underline ">richard@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td class="border-left">Byung-hyun Yoon</td>
                            <td><a href="mailto:bhyoon@kiesys.co.kr" class="primary--text text-decoration-underline ">bhyoon@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td class="border-left">Tae-hong Lee</td>
                            <td><a href="mailto:thlee@kiesys.co.kr" class="primary--text text-decoration-underline ">thlee@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td class="border-left">Jin-kyu Oh</td>
                            <td><a href="mailto:tedd@kiesys.co.kr" class="primary--text text-decoration-underline ">tedd@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td class="border-left">Jae-ho Roh</td>
                            <td><a href="mailto:jhroh@kiesys.co.kr" class="primary--text text-decoration-underline ">jhroh@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td>Corrosion Monitoring System</td>
                            <td>Seong-cheol Jeong</td>
                            <td><a href="mailto:jay@kiesys.co.kr" class="primary--text text-decoration-underline ">jay@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td>Partnership & PQ</td>
                            <td>Jae-ho Roh</td>
                            <td><a href="mailto:jhroh@kiesys.co.kr" class="primary--text text-decoration-underline ">jhroh@kiesys.co.kr</a></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </section>

        <section class="section section--last pt-0">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit top-line-tit">Contact KIE SYSTEMS</h3>
                </div>

                <!-- <form-input code="contactus" skin="contactus"></form-input> -->
                <form-input skin="contactus"></form-input>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import FormInput from "@/components/client/en/form/form-input.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        FormInput,
    },
};
</script>

<style lang="scss" scoped></style>
